import React from 'react';
import TemplatePage, { TemplateSection } from './TemplatePage';

// F9 (McKayla Loom "Current Site Feedback Part 2" t=3:44, ClickUp 86bah7dqn).
// Verbatim, in full: "We do need frequently asked questions. So I love that."
//
// ⛔ There are no approved answers, so this page asks no questions and gives
// none. Writing plausible FAQ entries would put unreviewed claims about a
// compliance-bound financial product in front of the public under our name.
// The questions and answers are McKayla's (plan Q4).
export default function FAQ() {
  return (
    <TemplatePage
      title="Frequently asked questions"
      intro="A placeholder for the FAQ. The questions and their answers are still to be written — nothing is drafted here on purpose, because an answer about how this product works is not ours to invent."
    >
      <TemplateSection
        heading="Questions go here"
        body="Each approved question and answer will render as its own entry."
      />
    </TemplatePage>
  );
}
